import { render, staticRenderFns } from "./WineTypeList.vue?vue&type=template&id=7c810a38"
import script from "./WineTypeList.vue?vue&type=script&lang=ts"
export * from "./WineTypeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports